import styled from 'styled-components'

export const StepContent = styled.div`
  max-width: 600px;
  padding: 15px;
  background: #222426;
  line-height: 1.5;
  font-family: var(--font-sans-serif);
  font-size: 0.95em;
  -webkit-font-smoothing: antialiased;
  position: relative;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  color: white;

  // ${({ theme }) => theme.breakpoints.up('xxxl')} {
  //   transform: translateX(-100%);
  // }

  p:first-child {
    margin-top: 0;
  }
`

export const Strong = styled.strong<{colored?: boolean}>`
  color: ${({ theme, colored }) => colored ? 'white' : '#121212'};
  font-family: var(--font-sans-serif);
  background: ${({ theme, colored }) => colored ? '#34373a' : `rgba(${theme.mainColor}, 1)`};
  padding: 0em 0.2em;
  font-weight: normal;
`
